// extracted by mini-css-extract-plugin
export default {"oval_btn":"OvalButton_oval_btn__qpJGo","mod":"OvalButton_mod__mMBXK"};